import { AppCurrencyPipe } from '../../lib-pipes/app-currency/app-currency.pipe';
import { AppNumberPipe } from '../../lib-pipes/app-number/app-number.pipe';
import { HoursToTimePipe } from '../../lib-pipes/hours-to-time/hours-to-time.pipe';

import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'segment-value',
  templateUrl: './segment-value.component.html',
  styleUrls: ['./segment-value.component.scss'],
  providers: [
    HoursToTimePipe,
    AppCurrencyPipe,
    AppNumberPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SegmentValueComponent implements OnInit, OnChanges {

  @HostBinding('class.-boldValue') @Input() bold_value: boolean = false;

  @Input() segment: any = null;
  // OR
  @Input() unit_value: number = null;
  @Input() unit_type: string = null;

  @Input() reverse_display: boolean = false;
  @Input() hide_hours_unit_type: boolean = false;
  @Input() hours_as_decimal: boolean = false;

  display_value: string = '';
  display_unit: string = '';

  constructor(
    public hoursToTimePipe: HoursToTimePipe,
    public appCurrencyPipe: AppCurrencyPipe,
    public appNumberPipe: AppNumberPipe
  ) { }

  ngOnInit() {
    this._updateDisplayValue();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.segment || !!changes.unit_value || !!changes.unit_type) {

      if (!!changes.unit_value){
        this.unit_value = this.unit_value || 0;
      }
      if (!!changes.unit_type) {
        this.unit_type = this.unit_type?.toLowerCase() || null;
      }
      this._updateDisplayValue();
    }
  }

  private _updateDisplayValue() {
    const unit_type = this._getUnitType();
    const unit_value = this._getUnitValue();

    if (unit_type === 'hours' || !unit_type) {
      this.display_value = this.hours_as_decimal ? this.appNumberPipe.transform(unit_value) : this.hoursToTimePipe.transform(unit_value);
      this.display_unit = unit_value === 1 && !this.reverse_display ? 'hour' : 'hours';
    }
    else if (unit_type === '$' || unit_type === 'expense') {
      this.display_value = this.appCurrencyPipe.transform(unit_value);
      this.display_unit = null;
    }
    else {
      this.display_value = this.appNumberPipe.transform(unit_value);
      if (unit_type === 'days') {
        this.display_unit = unit_value === 1 && !this.reverse_display ? 'day' : 'days';
      }
      else {
        this.display_unit = unit_type;
      }
    }
  }

  private _getUnitType(): string {
    if (!!this.segment) {
      return this.segment.unit_type || 'hours';
    }
    return this.unit_type;
  }

  private _getUnitValue(): number {
    if (!!this.segment) {
      return this.segment.duration || this.segment.units;
    }
    return this.unit_value;
  }

}
